import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "../../components/public/Header";
import Footer from "../../components/public/Footer";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfo, clearUserInfo } from "../../store/auth/authSlice";
import { useGetUserQuery } from "../../store/auth/usersApiSlice";
import { Modal, SessionExpired } from "../../components/common";
import { useSessionManager } from "../../Hooks/useSessionManager";
import Login from "./Login";

const RootLayout = ({ liftHeader = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.auth);
  const { data, refetch, isSuccess, isError, error } = useGetUserQuery(token, {
    skip: !token,
  });
  const [isSessionExpired, setSessionExpired] = useState(false);
  const sessionExpiredPopup = () => {
    setSessionExpired(!isSessionExpired);
    dispatch(clearUserInfo());
    navigate("/login");
  };
  useEffect(() => {
    if (isError) {
      if (error?.data?.code == 'token_not_valid') {
        setSessionExpired(true);
      }
    }
    if (isSuccess) {
      dispatch(setUserInfo({ ...data }));
    }
  }, [data, dispatch, isSuccess, isError]);

  // useEffect(() => {
  //   if (data) {
  //     refetch();
  //   }
  // }, [refetch, data]);
  return (
    <>
      {isSessionExpired && <Modal modalHandle={sessionExpiredPopup}>
        <SessionExpired handleNavigate={sessionExpiredPopup} />
      </Modal>}
      <Header liftHeader={liftHeader} />
      <Outlet />
      <Footer />
      
    </>
  );
};

export default RootLayout;
